import Swiper from "swiper";
var swiperLinksGrid = new Swiper(".link-grid-swiper-container", {
	breakpoints: {
		simulateTouch: true,
		draggable: true,
		320: {
			slidesPerView: 1,
			spaceBetween: 0
		},
		992: {
			slidesPerView: 3,
			spaceBetween: 0
		}
	}
});